import { Box, Container, Typography } from "@mui/material";
import CircularCarousel from "./CircularCarousel";

import Reglamento from "./Reglamento";
import { circularCarouselText } from "../../data/data";

import {ScrollStatic, ScrollMove} from "../../components/common/ScrollItem";
import TextToSpeech from "../../components/TextToSpeech";

const Nosotros = () => {
    const accessibilityText = `
      Comunicate al área correspondiente, procura marcar primero al numero telefonico y despues agregar la extension en pantalla.
      Los numeros a marcar son tres once docientos once noventaicuatro setenta o tambien tres once docientos catorce cero cero ochentaitres.
    `;

    const paymentItems = [
      "La cuenta del hospital puede liquidarse en efectivo, tarjeta de crédito o débito, o transferencia bancaria en el área de caja.",
      "Para ingresar a hospitalización se requiere un depósito mínimo de $10,000 para tratamiento médico; $15 mil a $20 mil en cirugías; $60 mil para ingresar a la Unidad de Terapia Intensiva. Si requiere material de osteosíntesis deberá cubrir el costo de dicho material antes de realizar la cirugía.",
      "Diariamente el área de caja le entregará oportunamente su estado de cuenta, el cual deberá estar cubierto al 100% preferentemente, como mínimo al 80%.",
      "Si desea factura, externarlo con anticipación; es necesario brindar datos correctos (CSF actualizada preferentemente y correo electrónico al momento de pagar la cuenta).",
      "El pago y facturación de honorarios médicos es independiente del pago del hospital, por lo que deberá tratarlo directamente con su médico.",
      "La forma de pago de honorarios médicos en el área de caja podrá ser en efectivo, tarjeta o transferencia; otro medio de pago deberá tratarlo directamente con su médico.",
      "Al momento del alta, caja le notificará el saldo total para liquidar al 100%.",
      "No está autorizada la firma de pagaré ni algún tipo de crédito.",
    ];
    
    const roomItems = [
      "Familiares y visitantes deberán registrarse al ingresar al hospital en el módulo de entrada con el personal de atención al cliente.",
      "El paciente solo podrá consumir alimentos con prescripción de su médico tratante, otorgados por el área de Dietología de acuerdo a su diagnóstico.",
      "Por seguridad del paciente, no se permite introducir alimentos externos a las habitaciones. Deberán consumirse en el área de comedor/restaurant.",
      "Para el cuidado del paciente el acceso permitido será de máximo 2 personas por habitación. En caso de que sean varios familiares, deberán turnarse de 2 en 2. Por ninguna circunstancia el paciente deberá quedar sin acompañante.",
      "Evitar permanecer fuera de la habitación y generar ruido, por respeto a los demás pacientes y a la movilidad del personal operativo.",
      "El horario de visita para pacientes es de 8:00 a 20:00 horas.",
      "Por disposición de la Secretaría de Salud queda prohibido el ingreso a menores de 10 años (en caso necesario se firma una responsiva y deberá permanecer dentro de la habitación).",
      "Respete las áreas comunes del hospital y la habitación. Si algún mueble o pertenencia del hospital presenta daño durante su estancia, tendrá que ser cubierto para su reparación o reposición.",
      "Todo paciente que requiera cuidados intensivos se trasladará al área correspondiente con sus respectivos cargos y lineamientos (información de costos en área de Caja).",
      "Si al momento del alta el paciente requiere una prenda propiedad del hospital (bata, sábana, toalla, etc.), ésta le será facturada para su pago inmediato.",
      "Se prohíbe fumar, tomar alcohol o drogas dentro y fuera de las instalaciones hospitalarias, incluyendo las terrazas y la periferia del hospital.",
      "Los controles de TV serán devueltos al área de Recepción; presente el vale en caja al momento de la liquidación de su cuenta.",
      "Después de liquidar la cuenta tendrá 1 hr para dejar la habitación. Para determinar el costo de la estancia en habitación, deberán acudir al área de caja.",
      "Se realizará un cargo de desinfección de habitación cuando el diagnóstico hospitalario sea por alguna enfermedad infecto-contagiosa; así como en caso de cambio de habitación, se aplicará el cargo correspondiente de desinfección en ambas habitaciones.",
      "Se prohíbe la introducción de medicamentos e insumos médicos externos, por seguridad del paciente y por su trazabilidad.",
      "No nos hacemos responsables por los objetos personales de valor olvidados o extraviados en la habitación y áreas comunes, a menos que sean depositados en la administración del hospital.",
    ];
  return (
    <Box
      sx={{
        width: "100%",
        backgroundSize: "100% 20%",
        backgroundRepeat: "no-repeat",
        mb: { xs: "5px", sm: "10px" },
        overflow: "auto",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 15 },
          maxWidth: "100% !important",
          pl: "0 !important",
          pr: "0 !important",
        }}
      >
        <TextToSpeech text={accessibilityText} />

        <ScrollStatic>
          <Typography
            variant="h1"
            align="center"
            sx={{
              width: "100%",
              color: "#194AC1",
              p: "0 35px"
            }}
          >
            Nosotros
          </Typography>
        </ScrollStatic>
      </Container>

      <ScrollMove>
        <Reglamento
          title="Reglamento de habitaciones para pacientes y familiares"
          sections={[
            { id: "pago", title: "Forma de pago", items: paymentItems },
            { id: "habitaciones", title: "Reglamento de habitaciones", items: roomItems, fullWidth: true },
          ]}
        />
      </ScrollMove>

      <ScrollStatic>
        <CircularCarousel items={circularCarouselText} rotateSpeed={65} cardWidth="28%" />
      </ScrollStatic>


    </Box>
  );
};

export default Nosotros;
